import { apiClient, getPlatformUrl } from "../../lib/api";
import { getIsNewDb } from "../../lib/is-new-db";
import { CausalAssetAnalysisListRequest, DwModelListRequest, DwModelRequest, DatasetRequest } from "./type/causal-asset";
import { adaptCausalAssetAnalysisListRequest, adaptDwModelListRequest } from "./adapter/causal-asset";

export class SharedGateway {
  async fetchConfigDef(req: any): Promise<any> {
    // ノード名変換・単位表示のマスタは causal_db の data_properties を使用する。
    // asset_id を指定すると当該アセットの column_properties を取得。未指定は既定値。
    const assetId = req?.asset_id;
    const base = `${getPlatformUrl()}/xcausal/v1/data_manager/data_properties`;
    const url = assetId
      ? `${base}?asset_id=${encodeURIComponent(assetId)}`
      : base;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchQueryDef(): Promise<any> {
    // 2 フェーズ取込 = v3 querybar (value_label 対応)。legacy = v1。
    const ver = getIsNewDb() ? "v3" : "v1";
    const url = `${getPlatformUrl()}/xcausal/${ver}/querybar`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchIdCodeDef(req: any): Promise<any> {
    const ver = getIsNewDb() ? "v3" : "v1";
    const url = `${getPlatformUrl()}/xcausal/${ver}/querybar/context`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async fetchNodeDef(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/v2/graph/nodes/outcome?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchCausalAssetAnalysisList(req: CausalAssetAnalysisListRequest): Promise<any> {
    const query = adaptCausalAssetAnalysisListRequest(req);
    const url = `${getPlatformUrl()}/causal-inference/analysis?${query}`;
    const res = await apiClient.get({ url: url, useToken: true });
    return res as any;
  }

  async fetchDwModelList(req: DwModelListRequest): Promise<any> {
    const query = adaptDwModelListRequest(req);
    const url = `${getPlatformUrl()}/causal-inference/analysis/${req.analysis_id}/dwmodel?${query}`;
    const res = await apiClient.get({ url: url, useToken: true });
    return res as any;
  }

  async fetchDwModel(req: DwModelRequest): Promise<any> {
    const url = `${getPlatformUrl()}/causal-inference/dwmodel/${req.model_id}`;
    const res = await apiClient.get({ url: url, useToken: true });
    return res;
  }

  async fetchDataset(req: DatasetRequest): Promise<any> {
    const url = `${getPlatformUrl()}/causal-inference/dataset/${req.dataset_metadata_id}`;
    const res = await apiClient.get({ url: url, useToken: true });
    return res;
  }

  async fetchGraphParameters(req: DwModelRequest): Promise<any> {
    const base = getPlatformUrl();
    const url = `${base}/xcausal/v2/graph/parameters/${req.model_id}`;
    const res = await apiClient.get({ url: url, useToken: true });
    return res;
  }
}
